import React from 'react';
import DateRangeSelector from './DateRangeSelector';
import StandaloneSection from './StandaloneSection';
import './GranularityDateRangeControls.css';

// Timeframe configurations
type TimeframeKey = '1m' | '5m' | '15m' | '30m' | '1h' | '4h' | '1d';

interface TimeframeConfig {
  label: string;
  granularityMins: number;
}

export const TIMEFRAMES: Record<TimeframeKey, TimeframeConfig> = {
  '1m': { label: '1 Minute', granularityMins: 1 },
  '5m': { label: '5 Minutes', granularityMins: 5 },
  '15m': { label: '15 Minutes', granularityMins: 15 },
  '30m': { label: '30 Minutes', granularityMins: 30 },
  '1h': { label: '1 Hour', granularityMins: 60 },
  '4h': { label: '4 Hours', granularityMins: 240 },
  '1d': { label: 'Daily', granularityMins: 1440 },
};

export type { TimeframeKey };

interface GranularityDateRangeControlsProps {
  selectedTimeframe: TimeframeKey;
  onTimeframeChange: (timeframe: TimeframeKey) => void;
  isLoading?: boolean;
}

const GranularityDateRangeControls: React.FC<GranularityDateRangeControlsProps> = ({
  selectedTimeframe,
  onTimeframeChange,
  isLoading = false,
}) => {
  return (
    <StandaloneSection title="GRANULARITY & DATE RANGE">
      <div className="intelligence-controls">
        {/* Timeframe Selector */}
        <div className="control-group">
          <div className="timeframe-buttons">
            {(Object.keys(TIMEFRAMES) as TimeframeKey[]).map((tf) => (
              <button
                key={tf}
                className={`timeframe-button ${selectedTimeframe === tf ? 'active' : ''}`}
                onClick={() => onTimeframeChange(tf)}
                disabled={isLoading}
              >
                {tf.toUpperCase()}
              </button>
            ))}
          </div>
        </div>

        {/* Date Range Selector */}
        <div className="date-range-selector-wrapper">
          <DateRangeSelector />
        </div>
      </div>
    </StandaloneSection>
  );
};

export default GranularityDateRangeControls;

